import { render, staticRenderFns } from "./WomensVersionMessage.vue?vue&type=template&id=dddf2b86&scoped=true"
import script from "./WomensVersionMessage.vue?vue&type=script&lang=js"
export * from "./WomensVersionMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddf2b86",
  null
  
)

export default component.exports